<template>
  <div class="foot">
    <div class="section">
      <div class="section_l">
        <img :src="require('../assets/img/logo_footer.png')" alt="" />
        <div class="slogan">专注于中小企业全渠道新零售业务的<br>ERP管理软件服务商</div>
      </div>
      <div class="section_m">
        <dl>
          <dt>解决方案</dt>
          <dd><a href="#/price">电商版</a></dd>
          <dd><a href="#/price">企业版</a></dd>
          <dd><a href="#/price">全渠道版</a></dd>
        </dl>
        <dl>
          <dt>合作案例</dt>
          <dd><a href="#/example">商家案例</a></dd>
        </dl>
        <dl>
          <dt>合作伙伴</dt>
          <dd><a href="#/friend">电商平台</a></dd>
          <dd><a href="#/friend">第三方仓储</a></dd>
        </dl>
        <dl>
          <dt>关于我们</dt>
          <dd><a href="#/about">公司介绍</a></dd>
          <dd><a href="#/about">发展历程</a></dd>
          <dd><a href="#/about">联系我们</a></dd>
        </dl>
      </div>
      <div class="section_r">
        <div class="contact">
          <div class="item">
            <img :src="require('../assets/img/icon_mail.png')" alt="" />
            <div class="item_popover">
              <a href="mailto:yushan@yushanyun.net">yushan@yushanyun.net</a>
            </div>
          </div>
          <div class="item">
            <img :src="require('../assets/img/icon_phone.png')" alt="" />
            <div class="item_popover">
              18930371050
              <!--<a href="tel:18930371050">18930371050</a>-->
              <!--<img :src="require('../assets/img/code_wechat.png')" alt="" />-->
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="copyright">
      <span style="margin-right: 5px">Copyright © 2019-{{ (new Date()).getFullYear() }} 域善科技 版权所有</span>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="text-decoration:none">沪ICP备19012510号-1</a>
      <a target="_blank" href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402334622" style="text-decoration:none">
        <img src="../assets/img/beian.png" style="width: 14px;margin-right: 5px;vertical-align: text-top;" alt="备案图标">
        <span>沪公网安备 31010402334622号</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  components: {}
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 1200px) {
  .foot {
    background: #27384E;
    color: rgba(255, 255, 255, 0.3);
    font-size: 14px;

    a {
      margin-left: 6px;
      color: rgba(255, 255, 255, 0.3);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .copyright {
      width: 1200px;
      margin: 0 auto;
      height: 52px;
      line-height: 52px;
      text-align: center;
      font-size: 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .section {
      display: flex;
      width: 1200px;
      padding: 36px 0 40px;
      margin: 0 auto;

      .section_l {
        width: 280px;

        img {
          height: 48px;
          margin-bottom: 18px;
        }

        .slogan {
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          opacity: 0.3;
        }
      }

      .section_m {
        flex: 1;
        display: flex;
        justify-content: space-between;


        dl {
          margin: 0;
        }

        dt {
          margin-bottom: 10px;
          font-weight: bold;
        }

        dd {
          margin: 0;
          line-height: 36px;

          a {
            margin-left: 0;
          }

        }
      }

      .section_r {
        margin-left: 110px;

        .contact {
          display: flex;
          justify-content: right;

          .item {
            position: relative;
            width: 44px;
            height: 44px;
            margin-left: 20px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            & > img {
              width: 20px;
              height: 20px;
            }

            .item_popover {
              position: absolute;
              left: 50%;
              bottom: 55px;
              transform: translateX(-50%);
              //width: 112px;
              padding: 6px;
              background: #FFFFFF;
              color: #666;
              box-shadow: 10px 12px 40px 0 rgba(51, 51, 51, 0.28);
              border-radius: 4px;
              display: none;

              &:before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: -20px;
                height: 30px;
                opacity: 0;
                z-index: 2;
              }

              &:after {
                content: "";
                position: absolute;
                left: 50%;
                top: 100%;
                margin-left: -6px;
                border-left: 6px solid transparent;
                border-top: 6px solid #fff;
                border-right: 6px solid transparent;
                border-bottom: 6px solid transparent;
              }

              img {
                width: 100%;
              }

              a {
                color: #666;
              }

            }


            &:hover {
              background: rgba(255, 255, 255, 0.2);

              .item_popover {
                display: block;

              }
            }
          }
        }
      }

    }
  }
}

@media screen and (max-width: 1200px) {
  .foot {
    height: .8rem;
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center;
    background: #27384E;
    color: rgba(255, 255, 255, 0.3);
    font-size: .14rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 .2rem;

    a {
      margin-left: 6px;
      color: rgba(255, 255, 255, 0.3);
    }

    .section {
      display: none;
    }
  }
}
</style>
